$(document).ready(function() {

  if ($('header').hasClass('home')) {
    setupHome();
  }

  /*$(window).on("scroll", function() {
    $('header').css({'margin-top':'-80px','display':'none'});
  });*/

  /*$(window).scrollEnd(function(){
      $('header').css('top',$(window).scrollTop());
      $('header').css('display','block');
      $('header').animate({marginTop:0},600);
  }, 1000);*/

  /* footnotes */
  $('span.footnote').click(function(){
    $("dl[data-noteId='"+$(this).attr('data-noteId')+"']").slideToggle(500);
  });


  // navigation
  $('.hamburger').click(function(){
    $(this).toggleClass('is-active');
    $('header, header nav').toggleClass('open');
    $('header').removeClass('fullscreen');
    if($(window ).height()<700 && $('header').hasClass('open')) {
      $('header').addClass('fullscreen');
    }
  });

});

function setupHome() {

  var se=$(window).width();
  var ve=$(window).height();

  var rtime;
  var timeout = false;
  var delta = 200;
  $(window).resize(function() {
      rtime = new Date();
      if (timeout === false) {
          timeout = true;
          setTimeout(resizeend, delta);
      }
  });

  var resizeend = function() {
      if (new Date() - rtime < delta) {
          setTimeout(resizeend, delta);
      } else {
          timeout = false;
          se=$(window).width();
          ve=$(window).height();
          calculatePoly();
          $('section.home h1').css("margin-top",ve/2+100);
      }
  }

  $('section.home h1').css("margin-top",ve/2+100);
  // setup
  var poly11 = '1500,1614 1605,1512 1605,1730 1500,1834';
  var poly12 = '1621,1500 1834,1500 1730,1604 1621,1604';
  var poly13 = '1741,1617 1845,1512 1845,1725 1751,1725 1741,1725 1741,1725';
  var poly14 = '1616,1741 1834,1741 1730,1845 1513,1845 1513,1845';
  //
  var poly21 = '1608,1613 1608,1706 1513,1706 1513,1706';
  var poly22 = '1624,1600 1854,1600 1854,1831 1624,1831';
  var poly23 = '1500,1722 1608,1722 1608,1845 1730,1845 1730,1954 1500,1954';
  var poly24 = '1745,1845 1843,1845 1745,1942 1745,1942 1745,1942';
  //
  var poly31 = '1500,1716 1608,1622 1608,1842 1500,1943';
  var poly32 = '1624,1600 1841,1600 1744,1716 1624,1716';
  var poly33 = '1749,1732 1854,1612 1854,1843 1751,1943 1751,1943 1751,1943';
  var poly34 = '1626,1726 1730,1726 1730,1954 1516,1954 1626,1852';
  //
  var poly11b=poly11c=poly11d=poly12b=poly12c=poly12d=poly13b=poly13c=poly13d=poly14b=poly14c=poly14d=null;
  var calculatePoly = function() {
    sc=304;
    poly11b = (1500-((se-sc)/2))+',1598 '+(1604-((se-sc)/2)+250)+',1500 '+(1604-((se-sc)/2))+',1738 '+(1500-((se-sc)/2))+',1834';
    poly11c = (1500-((se-sc)/2))+',1598 '+(1604-((se-sc)/2)+se)+',1500 '+(1604-((se-sc)/2)+400)+',1738 '+(1500-((se-sc)/2))+',1834';
    poly11d = (1500-((se-sc)/2))+',1498 '+(1604-((se-sc)/2)+150)+',1300 '+(1604-((se-sc)/2)+40)+',1838 '+(1500-((se-sc)/2))+',1834';
    sc=404;
    poly12b = '1625,'+(1500-((ve-sc)/2))+' 1834,'+(1500-((ve-sc)/2))+' 1736,'+(1601-((ve-sc)/2)+100)+' 1625,'+(1601-((ve-sc)/2));
    poly12c = '1625,'+(1500-((ve-sc)/2))+' 1834,'+(1500-((ve-sc)/2))+' 1736,'+(1601-((ve-sc)/2)+100)+' 1325,'+(1601-((ve-sc)/2)+400);
    poly12d = '1505,'+(1500-((ve-sc)/2))+' 1934,'+(1500-((ve-sc)/2))+' 1736,'+(1601-((ve-sc)/2)+70)+' 1625,'+(1501-((ve-sc)/2)+30);
    sc=304;
    poly13b = (1751+((se-sc)/2)-200)+',1624 '+(1854+((se-sc)/2))+',1522 '+(1854+((se-sc)/2))+',1732 '+(1751+((se-sc)/2))+',1732 '+(1751+((se-sc)/2))+',1732 '+(1751+((se-sc)/2))+',1732';
    poly13c = (1751+((se-sc)/2)-200)+',1624 '+(1854+((se-sc)/2))+',1522 '+(1854+((se-sc)/2))+',1732 '+(1751+((se-sc)/2))+',1732 '+(1451+((se-sc)/2))+',1932 '+(1451+((se-sc)/2))+',1932';
    poly13d = (1751+((se-sc)/2)-160)+',1564 '+(1854+((se-sc)/2)-10)+',1502 '+(1854+((se-sc)/2))+',1732 '+(1751+((se-sc)/2))+',1932 '+(1751+((se-sc)/2))+',1932 '+(1751+((se-sc)/2))+',1732';
    sc=104;
    poly14b = '1620,'+(1754+((ve-sc)/2)-200)+' 1839,'+(1754+((ve-sc)/2))+' 1741,'+(1854+((ve-sc)/2))+' 1513,'+(1854+((ve-sc)/2))+' 1513,'+(1854+((ve-sc)/2));
    poly14c = '1220,'+(1754+((ve-sc)/2)-400)+' 1939,'+(1754+((ve-sc)/2))+' 1741,'+(1854+((ve-sc)/2))+' 1513,'+(1854+((ve-sc)/2))+' 1513,'+(1854+((ve-sc)/2));
    poly14d = '1580,'+(1754+((ve-sc)/2)-100)+' 1939,'+(1754+((ve-sc)/2))+' 1741,'+(1854+((ve-sc)/2))+' 1313,'+(1854+((ve-sc)/2))+' 1313,'+(1854+((ve-sc)/2));
  }
  calculatePoly();
  // initial polygon
  var draw = SVG('drawing');
  var poly1 = draw.polygon(poly11);
  var poly2 = draw.polygon(poly12);
  var poly3 = draw.polygon(poly13);
  var poly4 = draw.polygon(poly14);
  var elements = SVG.select('polygon').fill('#ec4259').attr({stroke:'#fff','stroke-width':0});
  poly1.attr('id','poly1');
  poly2.attr('id','poly2');
  poly3.attr('id','poly3');
  poly4.attr('id','poly4');
  // loop
  var screen = 1;
  $(window).scroll(function () {
    var scrolled = $(this).scrollTop();
    if(scrolled < 60 && screen==1) {
      $('section.home h1').removeClass('animate');
      $('body').removeClass('green');
      $('section.items div.cooperation').removeClass('animate');
      $('section.items div.about').removeClass('animate');
    }
    else if(scrolled > 60 && scrolled < 900) {
      $('section.home h1').addClass('animate');
      $('body').removeClass('green');
      $('section.items div.cooperation').removeClass('animate');
    }
    else if (scrolled > 900 && scrolled < 1800 && (screen==1 || screen==3)) {
      screen = 2;
      $('section.items div.about').addClass('animate');
      $('section.items div.about').css('display', 'block');
      $('section.items div.cooperation').css('display', 'none');
      $('section.items div.blog').css('display', 'none');
      $('body').removeClass('green');
      $('section.items div.cooperation').removeClass('animate');
      poly1.attr({ fill: '#ec4259' });
      poly2.attr({ fill: '#ec4259' });
      poly3.attr({ fill: '#ec4259' });
      poly4.attr({ fill: '#ec4259' });
      staggerPoints("#poly1", 0.5, {points:poly11d}, 0.1);
      staggerPoints("#poly2", 0.5, {points:poly12d}, 0.1);
      staggerPoints("#poly3", 0.2, {points:poly13d}, 0.1);
      staggerPoints("#poly4", 0.5, {points:poly14d}, 0.1);
    } else if (scrolled > 1800 && scrolled < 2700 && (screen==2 || screen==4)) {
      screen=3;
      $('section.items div.about').removeClass('animate');
      $('section.items div.cooperation').removeClass('animate');
      $('body').addClass('green');
      $('body').removeClass('blue');
      poly1.attr({ fill: '#1faf50' });
      poly2.attr({ fill: '#1faf50' });
      poly3.attr({ fill: '#1faf50' });
      poly4.attr({ fill: '#1faf50' });
      staggerPoints("#poly1", 0.5, {points:poly21}, 0.1);
      staggerPoints("#poly2", 0.5, {points:poly22}, 0.1);
      staggerPoints("#poly3", 0.5, {points:poly23}, 0.1);
      staggerPoints("#poly4", 0.5, {points:poly24}, 0.1);
    } else if (scrolled > 2700 && scrolled < 3600 && (screen==3 || screen==5)) {
      screen=4;
      $('body').addClass('green');
      $('body').removeClass('blue');
      $('section.items div.cooperation').addClass('animate');
      $('section.items div.cooperation').css('display', 'block');
      $('section.items div.blog').css('display', 'none');
      $('section.items div.about').css('display', 'none');
      $('section.items div.blog').removeClass('animate');
      poly1.attr({ fill: '#1faf50' });
      poly2.attr({ fill: '#1faf50' });
      poly3.attr({ fill: '#1faf50' });
      poly4.attr({ fill: '#1faf50' });
      staggerPoints("#poly1", 0.5, {points:poly11b}, 0.1);
      staggerPoints("#poly2", 0.5, {points:poly12b}, 0.1);
      staggerPoints("#poly3", 0.2, {points:poly13b}, 0.1);
      staggerPoints("#poly4", 0.5, {points:poly14b}, 0.1);
    } else if (scrolled > 3600 && scrolled < 4500 && (screen==4 || screen==6)) {
      screen=5;
      $('body').addClass('blue');
      $('body').removeClass('green');
      $('section.items div.cooperation').removeClass('animate');
      $('section.items div.blog').removeClass('animate');
      poly1.attr({ fill: '#2e5e94' });
      poly2.attr({ fill: '#2e5e94' });
      poly3.attr({ fill: '#2e5e94' });
      poly4.attr({ fill: '#2e5e94' });
      staggerPoints("#poly1", 0.5, {points:poly31}, 0.1);
      staggerPoints("#poly2", 0.5, {points:poly32}, 0.1);
      staggerPoints("#poly3", 0.5, {points:poly33}, 0.1);
      staggerPoints("#poly4", 0.5, {points:poly34}, 0.1);
    } else if (scrolled > 4500 && screen==5) {
      screen=6;
      $('body').addClass('blue');
      $('section.items div.cooperation').removeClass('animate');
      $('section.items div.blog').addClass('animate');
      $('section.items div.blog').css('display', 'block');
      $('section.items div.cooperation').css('display', 'none');
      $('section.items div.about').css('display', 'none');
      poly1.attr({ fill: '#2e5e94' });
      poly2.attr({ fill: '#2e5e94' });
      poly3.attr({ fill: '#2e5e94' });
      poly4.attr({ fill: '#2e5e94' });
      staggerPoints("#poly1", 0.5, {points:poly11c}, 0.1);
      staggerPoints("#poly2", 0.5, {points:poly12c}, 0.1);
      staggerPoints("#poly3", 0.5, {points:poly13c}, 0.1);
      staggerPoints("#poly4", 0.5, {points:poly14c}, 0.1);
    } else if (scrolled < 900 && screen==2) {
      screen = 1;
      $('section.home h1').removeClass('animate');
      $('section.items div.about').removeClass('animate');
      poly1.attr({ fill: '#ec4259' });
      poly2.attr({ fill: '#ec4259' });
      poly3.attr({ fill: '#ec4259' });
      poly4.attr({ fill: '#ec4259' });
      staggerPoints("#poly1", 0.5, {points:poly11}, 0.1);
      staggerPoints("#poly2", 0.5, {points:poly12}, 0.1);
      staggerPoints("#poly3", 0.5, {points:poly13}, 0.1);
      staggerPoints("#poly4", 0.5, {points:poly14}, 0.1);
    }
  });
}

// helpers
function staggerPoints(selector, duration, vars, stagger, onCompleteAll) {
  var numbersExp = /(?:(-)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
      element = document.querySelector(selector),
      startPoints = element.getAttribute("points").match(numbersExp),
      endPoints = vars.points.match(numbersExp),
      applyPoints = function() {
        element.setAttribute("points", startPoints.join(","));
      },
      copy = function(obj) {
        var o = {}, p;
        for (p in obj) {
          if (p !== "points") {
            o[p] = obj[p];
          }
        }
        return o;
      },
      tl = new TimelineLite({onUpdate:applyPoints, onComplete:onCompleteAll}),
      l = startPoints.length,
      obj, i;
  if (l !== endPoints.length) {
    console.log("Error: point quantities don't match");
  }
  for (i = 0; i < l; i+=2) {
    obj = copy(vars);
    obj[i] = parseFloat(endPoints[i]); //note: we need to make sure the values are converted from strings to numbers.
    obj[i+1] = parseFloat(endPoints[i+1]);
    startPoints[i] = parseFloat(startPoints[i]);
    startPoints[i+1] = parseFloat(startPoints[i+1]);
    tl.to(startPoints, duration, obj, stagger * i);
  }
  return tl;
}

function isFunction(functionToCheck) {
 return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}


$.fn.scrollEnd = function(callback, timeout) {
  $(this).scroll(function(){
    var $this = $(this);
    if ($this.data('scrollTimeout')) {
      clearTimeout($this.data('scrollTimeout'));
    }
    $this.data('scrollTimeout', setTimeout(callback,timeout));
  });
};



// WEBPACK FOOTER //
// app/frontend/javascripts/scripts.js